import { render } from "./WhoAmITalkingTo.vue?vue&type=template&id=0a5a96da&scoped=true"
import script from "./WhoAmITalkingTo.vue?vue&type=script&lang=js"
export * from "./WhoAmITalkingTo.vue?vue&type=script&lang=js"

import "./WhoAmITalkingTo.vue?vue&type=style&index=0&id=0a5a96da&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src3554799265/src/syndesi-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a5a96da"]])

export default __exports__